var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interactive-logo"},[_c('div',{staticClass:"logoBox",style:(("width: " + (this.widthPercent) + "%;"))},[_c('div',{staticClass:"logoFrame absolutePosition"}),_c('div',{staticClass:"logoImageBox"})])])}
var staticRenderFns = []

export { render, staticRenderFns }